/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import * as actions from 'state/action-types';
import receiveConnectionWebhooks from './receive-connection-webhooks';

/**
 * External dependencies
 */
import { get } from 'lodash';

export default (connectionId) => (dispatch) => {
    dispatch({
        type: actions.CONNECTION_WEBHOOKS_REQUEST,
    });

    return cecSdk
        .connectionWebhooks(connectionId)
        .getConnectionWebhooks()
        .then((connectionWebhooks) => {
            // dispatch({
            //     type: actions.CONNECTION_WEBHOOKS_REQUEST_SUCCESS,
            // });

            dispatch({ type: actions.CONNECTION_WEBHOOKS_REQUEST_SUCCESS, payload: { connectionWebhooks } });

            dispatch(receiveConnectionWebhooks(connectionWebhooks));
            return connectionWebhooks;
        })
        .catch((e) => {
            dispatch({ type: actions.CONNECTION_WEBHOOKS_REQUEST_FAILURE, error: e.message });
            throw e;
        });
};
